import React from "react"
import HeaderSection from "../../components/header-section"
import Sidebar from "../../features/sidebar/components/sidebar"
import SimulationManagement from "../../features/admin/components/simulation-management"

const ManageSimulationsPage: React.FC = () => {
  return (
    <div className="flex bg-[#F9FAFB] min-h-screen w-full overflow-hidden">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <HeaderSection />
        <main className="flex-1 overflow-y-auto p-6">
          <div className="max-w-7xl mx-auto">
            <SimulationManagement />
          </div>
        </main>
      </div>
    </div>
  )
}

export default ManageSimulationsPage
